<template>
	<div class="ft_phone flex2">
		<div class="ft_p1">COPYRIGHT © 2025 徐州市交通控股集团有限公司 ALL RIGHTS RESERVED.<span @click="toGongXin">{{ basic.beian }}</span></div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			basic: {}
		}
	},
	created() {
		this.jconfig();
	},
	methods: {
		async jconfig() {
			const res = await this.$api.jconfig();
			if (res.code == 1) {
				this.basic = res.data;
			}
		},
        toGongXin(){
            window.open('https://beian.miit.gov.cn/', '_blank');
        }
	}
}
</script>

<style lang="scss">
.ft_phone {
	background-color: #004098;
	height: 80px;
    padding: 0 0.3rem;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    .ft_p1{
        color: #fff;
        font-size: 16px;
        line-height: 1.6;
        text-align: center;
    }
}
</style>